import React, { useState, useCallback, useMemo } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites/dto/ResponseDto';
import { CitySelect } from '~/src/components/CitySelect';
import { IAgeRestriction } from '~/src/components/LandingBlock/Header';
import { ApiCity } from '~/src/services/api/api-content/geography/types';

import * as ST from './styled';
interface IPicture {
    src: string;
    alt: string;
}

interface IProps {
    logo?: IPicture;
    isAdmin: boolean;
    customStyles?: Record<string, any>;
    cityData: ICityData | Record<string, never>;
    ageRestriction?: IAgeRestriction;
}

export interface ICityData {
    city: ApiCity,
}

export const HeaderPanel = ({ isAdmin, customStyles, cityData = {}, ageRestriction }: IProps): JSX.Element => {
    const router = useRouter();

    const { city } = cityData;

    const { domain: cityDomain = 'perm', logoFull = '/landing/icons/domru.svg' } = city || {};
    const [citySelectIsOpen, setCitySelectIsOpen] = useState(false);

    const phone = useMemo(() => {
        if (cityData) {
            const { city } = cityData;
            return `+7 (${city?.phone_code}) ${city?.sale_phone}`;
        }
        return '';
    }, [cityData]);

    const openCitySelect = useCallback(() => {
        setCitySelectIsOpen(true);
    }, []);

    const closeCitySelect = useCallback((city?: ICitySatellite) => {
        setCitySelectIsOpen(false);
        if (city) {
            const href = window?.location?.href;
            const newHref = href.replace(cityDomain, city?.domain);
            router.push(newHref);
        }
    }, [router, cityDomain]);

    return (
        <ST.HeaderPanel>
            <ST.Row middle='sm' top='xs' start='xs' wrap='nowrap'>
                <ST.Col>
                    <Link href={`https://${cityDomain}.dom.ru`}>
                        <a>
                            <ST.Logo src={logoFull} role='img'/>
                        </a>
                    </Link>
                </ST.Col>
                <ST.GrowCol>
                    { cityData.city && (
                        <ST.Row between='sm'>
                            <ST.Col xs={12} sm={4}>
                                <ST.CurrentCity
                                    onClick={openCitySelect}
                                    {...customStyles}
                                    role='figure'
                                >
                                    {cityData?.city?.name}
                                </ST.CurrentCity>
                            </ST.Col>
                            <ST.PhoneCol xs={12} sm={5} >
                                <ST.Phone
                                    href={`tel:+${phone?.replace(/\D/g, '')}`}
                                    className='js-calltouch-phone'
                                    {...customStyles}
                                >
                                    {phone}
                                </ST.Phone>

                                {ageRestriction?.active && ageRestriction?.image &&
                                    <ST.Age backgroundColor={ageRestriction.backgroundColor} image={ageRestriction.image}/>
                                }
                            </ST.PhoneCol>
                             </ST.Row>
                    )}
                </ST.GrowCol>
            </ST.Row>
            {!isAdmin && citySelectIsOpen &&
                <CitySelect handleCitySave={closeCitySelect}/>
            }
        </ST.HeaderPanel>
    );
};
